import { useState } from "react";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section aria-labelledby="faq-title" className="bg-background-100 px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <p className="mb-2 text-xs font-medium tracking-[0.25em] text-primary-600">FAQ</p>
          <h2 id="faq-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于内容来源、更新节奏和投稿方式，这里整理了大家问得最多的几个问题。如果还有疑问，欢迎通过「关于我们」页面联系我们。
          </p>
        </div>

        <div className="lg:col-span-2">
          <dl className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <dt>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-primary-100/30 md:px-5"
                    >
                      <h3 className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</h3>
                      <i
                        className={`shrink-0 text-lg text-primary-500 transition-transform duration-300 ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      />
                    </button>
                  </dt>
                  <dd
                    className={`overflow-hidden px-4 text-sm leading-relaxed text-foreground-600 transition-all duration-300 md:px-5 ${
                      isOpen ? "max-h-60 pb-5 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    {item.a}
                  </dd>
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}